const conversionFactors = {
  Coulombs: 1,
  Millicoulombs: 1e-3,
  Microcoulombs: 1e-6,
  Nanocoulombs: 1e-9,
  Picocoulombs: 1e-12,
  'Ampere-hours': 3600,
  'Milliampere-hours': 3.6,
  Faradays: 96485.3321,
  'Elementary charges': 1.602176634e-19,
  Statcoulombs: 3.335641e-10,
  Abcoulombs: 10,
  'Planck charge': 1.875545956e-18
};

export const convertElectricalCharge = (value, fromUnit, toUnit) => {
  const valueInCoulombs = value * conversionFactors[fromUnit];
  return valueInCoulombs / conversionFactors[toUnit];
};
